import { render, staticRenderFns } from "./UsersCardRightPanelUsers.vue?vue&type=template&id=322995a6&scoped=true&"
import script from "./UsersCardRightPanelUsers.vue?vue&type=script&lang=ts&"
export * from "./UsersCardRightPanelUsers.vue?vue&type=script&lang=ts&"
import style0 from "./UsersCardRightPanelUsers.vue?vue&type=style&index=0&id=322995a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322995a6",
  null
  
)

export default component.exports